import { Link } from 'react-scroll';
import { Code, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="py-12 bg-gray-900/70 border-t border-gray-800">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo et copyright */}
          <div className="text-center md:text-left">
            <div className="flex items-center gap-2 mb-4">
              <Code className="text-primary" size={24} />
              <span className="text-xl font-bold">Portfolio<span className="text-primary">.</span></span>
            </div>
            <p className="text-gray-400">
              Tous droits réservés {new Date().getFullYear()} © Yannick HIEN.
            </p>
          </div>
          
          {/* Liens rapides */}
          <div className="flex flex-wrap gap-6 justify-center">
            <Link 
              to="home" 
              smooth={true} 
              duration={500}
              className="text-gray-400 hover:text-primary cursor-pointer transition-colors"
            >
              Accueil
            </Link>
            <Link 
              to="about" 
              smooth={true} 
              duration={500}
              className="text-gray-400 hover:text-primary cursor-pointer transition-colors"
            >
              À propos
            </Link>
            <Link 
              to="projects" 
              smooth={true} 
              duration={500}
              className="text-gray-400 hover:text-primary cursor-pointer transition-colors"
            >
              Projets
            </Link>
            <Link 
              to="contact" 
              smooth={true} 
              duration={500}
              className="text-gray-400 hover:text-primary cursor-pointer transition-colors"
            >
              Contact
            </Link>
          </div>
          
          {/* Bouton retour en haut */}
          <button
            onClick={scrollToTop}
            className="p-3 bg-gray-800 rounded-lg hover:bg-primary transition-colors group"
            aria-label="Retour en haut"
          >
            <ArrowUp className="group-hover:animate-bounce" />
          </button>
        </div>
        
        {/* Message de fin */}
        <div className="text-center mt-12 pt-8 border-t border-gray-800">
          <p className="text-gray-500">
            Disponible pour des opportunités de stage à partir de mai 2026
          </p>
          <p className="text-gray-600 text-sm mt-2">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;